<template>     
     <div>
   

   
         <ResetPassword/>
       
  </div>
  
</template>

<script>
import ResetPassword from '@/components/Auth/ResetPassword.vue';
export default {
components: {
      ResetPassword,
    },
}
</script>

<style scoped>

</style>
